<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!--RO No-->
				<el-col :span="3">
					<search-input :label="getMessage_('QWCC000976')" paramKey="roNo" @commInput="setSearchParam" :propData="searchParams.roNo" />
				</el-col>
				<!-- 캠페인번호-->
				<el-col :span="3">
					<search-input :label="getMessage_('MWCC001024')" paramKey="cmpnNo" @commInput="setSearchParam" :propData="searchParams.cmpnNo" />
				</el-col>
				<!--원인부품번호-->
				<el-col :span="3">
					<search-input :label="getMessage_('QWCC000975')" paramKey="partNo" @commInput="setSearchParam" :propData="searchParams.partNo" />
				</el-col>
				<!--생산법인-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001546')"
						paramKey="htwoCorp"
						:options="htwoCorpList"
						:propData="searchParams.htwoCorp"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col> -->
				<!--생산공장-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001540')"
						paramKey="plntCd"
						:options="plntCdList"
						:propData="searchParams.plntCd"
						@commChange="setSearchParam"
						:showAll="false"
					></select-combo>
				</el-col> -->
				<!--차량구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001015')"
						paramKey="carScn"
						:options="carScnList"
						:propData="searchParams.carScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--승상구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001017')"
						paramKey="pacScn"
						:options="pacScnList"
						:propData="searchParams.pacScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 부품유형-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000059')"
						paramKey="partType"
						:options="partTypeList"
						:propData="searchParams.partType"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--판매지역-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001019')"
						paramKey="saleRegn"
						:options="saleRegnList"
						:propData="searchParams.saleRegn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<!-- 정비유형
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001180')"
						paramKey="ceqType"
						:options="ceqTypeList"
						:propData="searchParams.ceqType"
						@commChange="setSearchParam"
					></select-combo>
				</el-col> -->
				<!--연료전지사양-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001021')"
						paramKey="flclSpc"
						:options="flclSpcList"
						:propData="searchParams.flclSpc"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- op코드 -->
				<el-col :span="4">
					<div class="qms-search-input sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001096') }}</span>
						<div class="search-option-wrapper__normal">
							<el-input
								:value="searchParams.opCdNm"
								@keyup.native.delete="deleteKeyDown()"
								:placeholder="getMessage_('QWCC001096')"
							></el-input>
							<i class="icon-sf-search search-icon" @click="() => onOpCdPopup()"></i>
						</div>
					</div>
				</el-col>
				<!--지수구분 -->
				<el-col :span="3">
					<div class="sf-input-group-wrapper">
						<select-combo
							:label="getMessage_('QWCC001563')"
							paramKey="idxScn"
							:options="idxScnList"
							:propData="searchParams.idxScn"
							@commChange="setSearchParam"
						></select-combo>
					</div>
				</el-col>
				<!--클레임타입-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001566')"
						paramKey="cType"
						:options="cTypeList"
						:propData="searchParams.cType"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--현상코드-->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001055')"
						paramKey="phmnCd"
						:options="phmnCdList"
						:propData="searchParams.phmnCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<div class="qms-search-input sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001595') }}</span>
						<div class="search-option-wrapper__normal">
							<el-input
								clearable
								:value="searchParams.strtTotCst"
								@input="val => setSearchParam({ key: 'strtTotCst', value: val })"
								:placeholder="getMessage_('QWCC001595')"
							>
							<template slot="append" >~</template>
							</el-input>
						</div>
					</div>
				</el-col>
				<!-- <el-col :span="1">
					<div class="qms-search-input sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('\u00A0') }}</span>
						<div class="search-option-wrapper__normal">~
						</div>
					</div>
				</el-col> -->
				<el-col :span="2">
					<span class="sf-input-group-wrapper__label">{{ getMessage_('\u00A0') }}</span>
					<div class="search-option-wrapper__normal">
						<el-input
							clearable
							:value="searchParams.endTotCst"
							@input="val => setSearchParam({ key: 'endTotCst', value: val })"
							:placeholder="getMessage_('QWCC001595')"
						></el-input>
					</div>
				</el-col>

				<!--처리단계-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000963')"
						paramKey="prcStepGb"
						:options="prcsStepList"
						:propData="searchParams.prcStepGb"
						@commChange="setSearchParam"
						:showAll="true"
					></select-combo>
				</el-col> -->
				<!--처리결과-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000978')"
						paramKey="prcRsltCd"
						:options="prcsRsltList"
						:propData="searchParams.prcRsltCd"
						@commChange="setSearchParam"
						:showAll="true"
					></select-combo>
				</el-col> -->
			</el-row>
			<el-row :gutter="20">
				<!--판매월-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC002075')"
						paramKey="srchMm01"
						:options="srchMm01List"
						:propData="searchParams.srchMm01"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--판매월-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-date-picker
							v-model="searchDate1"
							@change="changeSearchSrchMm01"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!--조건월-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC002080')"
						paramKey="srchMm02"
						:options="srchMm02List"
						:propData="searchParams.srchMm02"
						@commChange="setSearchParam"
						:showAll="true"
					></select-combo>
				</el-col>
				<!--조건월-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-date-picker
							v-model="searchDate2"
							@change="changeSearchSrchMm02"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!--특이사항검색-->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001594')"
						paramKey="prtlSbc"
						@commInput="setSearchParam"
						:propData="searchParams.prtlSbc"
					/>
				</el-col>
				<el-col :span="3">
					<search-input :label="getMessage_('QWCC001563')" paramKey="m3IdxScn" @commInput="setSearchParam" :propData="searchParams.m3IdxScn" hidden/>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<!--사용기간-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001053')"
						paramKey="useTerm"
						:options="useTermList"
						:propData="searchParams.useTerm"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--차량유형-->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001016')"
						paramKey="carTypeNm"
						:propData="searchParams.carTypeNm"
						@commInput="setSearchParam"
					/>
				</el-col>
				<!--누적-->
				<template v-if="this.pState16 == 'Y'">
					<el-col :span="2">
						<sf-group-wrapper :label="getMessage_('\u00A0')">
							<el-checkbox @input="value => onCheck('check', value)" checked>{{ getMessage_('QWCC001565') }}</el-checkbox>
						</sf-group-wrapper>
					</el-col>
				</template>
				<template v-else>
					<el-col :span="2">
						<sf-group-wrapper :label="getMessage_('\u00A0')">
							<el-checkbox @input="value => onCheck('check', value)">{{ getMessage_('QWCC001565') }}</el-checkbox>
						</sf-group-wrapper>
					</el-col>
				</template>
				
				<!--판매국가-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001542')"
						paramKey="saleNat"
						:options="saleNatList"
						:propData="searchParams.saleNat"
						@commChange="setSearchParam"
					></select-combo>
				</el-col> -->
			</el-row>
			<!-- <el-row :gutter="20">
			</el-row> -->
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcRoList/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //판매 시작월
		pEndDt: { type: String, default: '' }, //판매 종료월
		pStartDt2: { type: String, default: '' }, //조건 시작월
		pEndDt2: { type: String, default: '' }, //조건 종료월
		pState1: { type: String, default: '' }, //부품유형
		pState2: { type: String, default: '' }, //차량구분
		pState3: { type: String, default: '' }, //승상구분
		pState4: { type: String, default: '' }, //연료전지사양
		pState5: { type: String, default: '' }, //판매지역
		pState6: { type: String, default: '' }, //사용기간(3m,12m,WM)
		pState7: { type: String, default: '' }, //RO처리단계
		pState8: { type: String, default: '' }, //RO처리결과
		pState9: { type: String, default: '' }, //Ctype
		pState10: { type: String, default: '' }, //차종유형
		pState11: { type: String, default: '' }, //검색조건HTWO판매월
		pState12: { type: String, default: '' }, //검색조건 조건월
		pState13: { type: String, default: '' }, //사용기간(년)
		pState14: { type: String, default: '' }, //지수구분
		pState15: { type: String, default: '' }, //현상코드
		pState16: { type: String, default: '' }, //누적
		pState17: { type: String, default: '' }, //품번
		pState18: { type: String, default: '' } //정비유형
	} /*,
	data() {
		let fromDate = this.$moment().startOf('year').format('YYYY-MM-DD');
		let toDate = this.$moment().startOf('month').format('YYYY-MM-DD');
		return {
			searchDate1: [new Date(fromDate), new Date(toDate)],
			searchDate2: [new Date(fromDate), new Date(toDate)],
			fromDate: fromDate,
			toDate: toDate,
			chk1: true, //사용기간 체크박스1
			chk2: true, //사용기간 체크박스2
			chk3: false //사용기간 체크박스3
		};
	}*/,
	data() {
		return {
			searchDate1: ['', ''],
			searchDate2: ['', '']
		};
	},
	components: {
		SelectCombo,
		SearchInput
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			if (param.key == 'strtTotCst' || param.key == 'endTotCst') {
				const regEx = /[^0-9]/g; //숫자만 가능
				param.value = param.value.replace(regEx, '');
				param.value = param.value?.length > 10 ? param.value.slice(0, 10) : param.value;
			}
			if(param.key == 'idxScn' && param.value != 'M3'){
				this.setSearchParam_({key: 'm3IdxScn', value: ''})
			}
			this.setSearchParam_(param);
		},
		onCheck(key, value) {
			if (value) this.setSearchParam_({ key, value: 'Y' });
			else this.setSearchParam_({ key, value: 'N' });
		},
		searchList() {
			if (this.searchDate1 === null || this.searchDate2 === null) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001682')
				}); //필수 검색 값을 확인해주십시오
			} else {
				this.$sf_toggleLoading(true);
				this.getgrdList_()
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		changeSearchSrchMm01(data) {
			if (data === null || data === '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				}); //필수 검색 값입니다.
			} else {
				let from = this.$moment(data[0]).format('YYYY-MM-DD');
				let to = this.$moment(data[1]).format('YYYY-MM-DD');
				let today = this.$moment().startOf('month').format('YYYY-MM-DD');
				let diffMonth = this.$moment(today).diff(this.$moment(to), 'months');
				if (diffMonth < 0) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000008'),
						message: this.getMessage_('QWCC001678')
					}); //이번달까지 선택 가능합니다.
					this.searchDate1[0] = this.fromDate;
					this.searchDate1[1] = this.toDate;
				} else {
					this.selectDate1({ from, to });
				}
			}
		},
		changeSearchSrchMm02(data) {
			if (data === null || data === '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				});
			} else {
				let from2 = this.$moment(data[0]).format('YYYY-MM-DD');
				let to2 = this.$moment(data[1]).format('YYYY-MM-DD');
				let today = this.$moment().startOf('month').format('YYYY-MM-DD');
				let diffMonth = this.$moment(today).diff(this.$moment(to2), 'months');
				if (diffMonth < 0) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000008'),
						message: this.getMessage_('QWCC001678')
					}); //이번달까지 선택 가능합니다.
					this.searchDate2[0] = this.fromDate;
					this.searchDate2[1] = this.toDate;
				} else {
					this.selectDate2({ from2, to2 });
				}
			}
		},
		onOpCdPopup() {
			const commCd = {
				commCdType: 'OP_CD',
				commCd: this.searchParams.opCd,
				title: this.getMessage_('QWCC001096')
			};

			this.$emit('OpenOpPopup', commCd);
		},
		deleteKeyDown() {
			this.setSearchParam({ key: 'opCd', value: '' });
			this.setSearchParam({ key: 'opCdNm', value: '' });
		}
	},
	async created() {
		try {
			await this.$sf_toggleLoading(true);
			await this.postSearchSelectList_();
			//await this.setSearchParamInit_();

			/* 그래프 그리드 연결 파라미터 준비 */
			let pStartDt = this.pStartDt || ''; //판매 시작월
			let pEndDt = this.pEndDt || ''; //판매 종료월
			let pStartDt2 = this.pStartDt2 || ''; //조건 시작월
			let pEndDt2 = this.pEndDt2 || ''; //조건 종료월
			let pState1 = this.pState1 || ''; // 부품유형
			let pState2 = this.pState2 || ''; // 차량구분
			let pState3 = this.pState3 || ''; // 승상구분
			let pState4 = this.pState4 || ''; // 연료전지사양
			let pState5 = this.pState5 || ''; // 판매지역
			let pState6 = this.pState6 || ''; // 사용기간(3m,12m,WM)
			let pState7 = this.pState7 || ''; //RO처리단계
			let pState8 = this.pState8 || ''; //RO처리결과
			let pState9 = this.pState9 || ''; //Ctype
			let pState10 = this.pState10 || ''; //차종유형
			let pState11 = this.pState11 || ''; //판매월 검색조건
			let pState12 = this.pState12 || ''; //조건월 검색조건
			let pState13 = this.pState13 || ''; //사용기간(년)
			let pState14 = this.pState14 || ''; //지수구분
			let pState15 = this.pState15 || ''; //현상코드
			let pState16 = this.pState16 || ''; //누적
			let pState17 = this.pState17 || ''; //품번
			let pState18 = this.pState18 || ''; //정비유형

			//console.log('넘어온값', pState6);

			//파라미터 세팅 전 초기화
			if (pStartDt && pEndDt) {
				let setStartDt = this.$moment(pStartDt).format('YYYYMMDD');
				let setEndDt = this.$moment(pEndDt).format('YYYYMMDD');
				let setStartDt2 = this.$moment(pStartDt2).format('YYYYMMDD');
				let setEndDt2 = this.$moment(pEndDt2).format('YYYYMMDD');

				let from = setStartDt;
				let to = setEndDt;
				let from2 = setStartDt2;
				let to2 = setEndDt2;

				this.searchDate1 = [setStartDt, setEndDt];
				this.selectDate1({ from, to });
				this.searchDate2 = [setStartDt2, setEndDt2];
				this.selectDate2({ from2, to2 });

				this.setSearchParam_({ key: 'partType', value: pState1 }); //부품구분
				this.setSearchParam_({ key: 'carScn', value: pState2 }); //차량구분
				this.setSearchParam_({ key: 'pacScn', value: pState3 }); //승상구분
				this.setSearchParam_({ key: 'flclSpc', value: pState4 }); //연료전지사양
				this.setSearchParam_({ key: 'saleRegn', value: pState5 }); //판매지역
				this.setSearchParam_({ key: 'idxScn', value: pState6 }); //3M,12M
				this.setSearchParam_({ key: 'prcStepGb', value: pState7 }); //RO처리단게
				this.setSearchParam_({ key: 'prcRsltCd', value: pState8 }); //RO 처리결과
				this.setSearchParam_({ key: 'cType', value: pState9 }); //C_TYPE
				this.setSearchParam_({key: 'carTypeNm', value: pState10}); //차종유형
				this.setSearchParam_({ key: 'srchMm01', value: pState11 }); //판매월
				// this.setSearchParam_({ key: 'srchMm01', value: '30' }); //판매월
				this.setSearchParam_({ key: 'srchMm02', value: pState12 }); //조건월
				this.setSearchParam_({ key: 'phmnCd', value: pState15 }); //현상코드
				this.setSearchParam_({ key: 'ceqType', value: pState18 }); //정비유형
				this.setSearchParam_({ key: 'useTerm', value: pState13 }); //사용기간(년)
				this.setSearchParam_({ key: 'm3IdxScn', value: pState14 }); //지수구분
				this.setSearchParam_({ key: 'partNo', value: pState17 }); //품번
				// this.setSearchParam_({ key: 'partNo', value: '' }); //품번
				if (pState16 == 'Y') this.setSearchParam_({ key: 'check', value: 'Y' });
				else this.setSearchParam_({ key: 'check', value: 'N' });

				//console.log('setSearchParamInit_이거 되나 pStartDt', pStartDt);
				//console.log('setSearchParamInit_이거 되나 pEndDt', pEndDt);
				/*
				if (pState1 != '' && pState2 != '' && pState3 != '') {
					const pStartDt1 = this.$moment(pStartDt).format('YYYY-MM-DD');
					const pEndDt2 = this.$moment(pEndDt).format('YYYY-MM-DD');
					this.selectDate1({ pStartDt1, pEndDt2 });
					this.setSearchParam_({ key: 'prcRsltCd', value: pState1 });
					this.setSearchParam_({ key: 'pwaStartDt', value: pStartDt });
					this.setSearchParam_({ key: 'pwaEndDt', value: pEndDt });
				}
				*/
			} else {
				let fromDate = this.$moment().startOf('year').format('YYYY-MM-DD');
				let toDate = this.$moment().startOf('month').format('YYYY-MM-DD');

				this.searchDate1 = [new Date(fromDate), new Date(toDate)];
				this.searchDate2 = [new Date(fromDate), new Date(toDate)];
			}

			await this.searchList();
			await this.$sf_toggleLoading(false);
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
